/// <reference path="../_all.ts" />

module editor {
  'use strict';

  ContentListItemDirective.$inject = [
  ];

  export function ContentListItemDirective(
  ): ng.IDirective {

    return {
      restrict: 'AE',
      scope: {
        contentData: '=',
        selectedItem: '='
      },
      templateUrl: 'editor/ContentListItemDirective',
      link: function (scope: IContentListItemScope, element: ng.IAugmentedJQuery, attr: ng.IAttributes) {

        scope.getStatus = function (s: ContentMetaStatus) {
          var statusString = (s === 1) ? "Entwurf" : //@TODO vereinfachen (z.B. Fehleranfällig für Modifikationen…)
            s === 2 ? "Veröffentlicht" :
            s === 3 ? "Archiviert": ""
          return statusString;
        }

      }
    }

  }
}